import { sample } from "effector";
import {
  createEduUserFx,
  createUserFx, // Add this import
  getEduTemplateFx,
  getPotentialEmpEduFx,
  getPotentialEmpFx,
  getTemplateFx,
  getUserListEduFx,
  getUserListFx,
  sendEditUserFx,
  sendImportFilesFx,
} from "./effects";
import {
  $chosenEmpEduImgModal,
  $chosenEmpImgModal,
  $chosenPotentialEmp,
  $chosenPotentialEmpEdu,
  $chosenUser,
  $chosenViewEdu,
  $editUserEdu,
  $importFileModal,
  $importFilesErrors,
  $potentialEmp,
  $potentialEmpEdu,
  $showCreateModal,
  $userEmpCategory,
  $userList,
  $userListEdu,
  $userListPlaceId,
  $departmentsList,
} from "./stores";
import {
  addUserToListEv, // Add this import
  changeChosenEmpEduImgModalEv,
  changeChosenEmpImgModalEv,
  changeChosenPotentialEmpEduEv,
  changeChosenPotentialEmpEv,
  changeChosenUserEv,
  changeImportFileModalEv,
  changeShowCreateModalEv,
  changeUserEmpCategoryEv,
  changeUserListPlaceIdEv,
  createEduUserEv,
  fireEmployeeEv,
  getEduTemplateEv,
  getTemplateEv,
  resetEditUserEduEv,
  resetViewEduEv,
  sendImportFilesEDUEv,
  sendImportFilesHREv,
  setEditUserEduEv,
  setViewEduEv,
} from "./events";
import { formatUserListTable } from "./utils";

$chosenViewEdu.on(setViewEduEv, (_, payload) => payload).reset(resetViewEduEv);

$editUserEdu
  .on(setEditUserEduEv, (_, payload) => payload)
  .reset(resetEditUserEduEv);

// sample({
//   clock: getUserListFx.doneData,
//   fn: formatUserListTable,
//   target: $userList,
// });

sample({
  clock: getUserListFx.doneData,
  fn: (result) => formatUserListTable(result?.userList || []),
  target: $userList,
});

sample({
  clock: getUserListFx.doneData,
  fn: (result) => result?.placeIdentifiers || [],
  target: $departmentsList,
});

sample({
  clock: $userListPlaceId.updates,
  target: getUserListFx,
});

sample({
  clock: $userListPlaceId.updates,
  target: getPotentialEmpFx,
});

sample({
  clock: changeUserListPlaceIdEv,
  fn: (clock) => {
    return clock.value;
  },
  target: $userListPlaceId,
});

sample({
  clock: changeUserEmpCategoryEv,
  fn: (clock) => clock,
  target: $userEmpCategory,
});

sample({
  clock: changeChosenUserEv,
  target: $chosenUser,
});

sample({
  clock: sendEditUserFx.doneData,
  filter: (clock) => clock,
  fn: (clock) => {
    if (clock) return null;
  },
  target: $chosenUser,
});

sample({
  source: $userList,
  clock: sendEditUserFx.doneData,
  filter: (source, clock) => clock,
  fn: (source, clock) => {
    const clock_partition_key = clock.partition_key.split("#")[1];
    const changedUser = source.find(
      (user) => user.partition_key === clock_partition_key
    );
    return [
      ...source.filter((user) => user.partition_key !== clock_partition_key),
      {
        ...changedUser,
        ...clock,
        partition_key: clock_partition_key,
        sort_key: clock.sort_key.split("#")[1],
      },
    ];
  },
  target: $userList,
});

sample({
  clock: getPotentialEmpFx.doneData,
  fn: (clock) => {
    if (Array.isArray(clock)) {
      return clock;
    }
    return [clock];
  },
  target: $potentialEmp,
});

sample({
  clock: fireEmployeeEv,
  fn: (clock) => {
    if (!clock?.partition_key) {
      console.error("🚨 fireEmployeeEv received an invalid user:", clock);
      return null;
    }

    return {
      action: "update_employee",
      values: {
        user_id: clock.partition_key, // ✅ Correct user ID
        place_id: "amaa25d7c9", // ✅ Ensure correct place_id
        emp_category: "Уволен",
      },
    };
  },
  filter: (result) => result !== null, // Ensure invalid users are not passed
  target: sendEditUserFx,
});

sample({
  source: $showCreateModal,
  clock: changeShowCreateModalEv,
  fn: (source, clock) => {
    if (typeof clock === "boolean") {
      return clock;
    }
    return !source;
  },
  target: $showCreateModal,
});

sample({
  clock: changeChosenPotentialEmpEv,
  target: $chosenPotentialEmp,
});

sample({
  clock: changeChosenEmpImgModalEv,
  target: $chosenEmpImgModal,
});

sample({
  clock: createEduUserEv,
  target: createEduUserFx,
});

sample({
  clock: createEduUserFx.doneData,
  fn: () => false,
  target: $showCreateModal,
});

sample({
  clock: createEduUserFx.doneData,
  target: getPotentialEmpEduFx,
});

sample({
  clock: getUserListEduFx.doneData,
  fn: (clock) => {
    return clock.map((item, index) => ({
      ...item,
      key: `edu-item-${index}`,
    }));
  },
  target: $userListEdu,
});

sample({
  clock: $userEmpCategory.updates,
  fn: (clock) => clock,
  target: getUserListEduFx,
});

sample({
  source: $importFileModal,
  clock: changeImportFileModalEv,
  fn: (source, clock) => {
    if (typeof clock === "boolean") {
      return clock;
    }
    return !source;
  },
  target: $importFileModal,
});

sample({
  clock: sendImportFilesEDUEv,
  fn: (clock) => {
    return {
      link: "https://mass-onboarding.foqus-portal.live/process-files-edu",
      ...clock,
    };
  },
  target: sendImportFilesFx,
});

sample({
  clock: sendImportFilesHREv,
  fn: (clock) => {
    return {
      link: "https://mass-onboarding.foqus-portal.live/process-files",
      ...clock,
    };
  },
  target: sendImportFilesFx,
});

sample({
  clock: sendImportFilesFx.doneData,
  fn: (clock) => {
    return [
      clock.missing_employees_comment,
      clock.missing_images_comment,
      clock.name_surname_reversed_comment,
    ];
  },
  target: $importFilesErrors,
});

sample({
  clock: getEduTemplateEv,
  target: getEduTemplateFx,
});

sample({
  clock: getTemplateEv,
  target: getTemplateFx,
});

sample({
  clock: getPotentialEmpEduFx.doneData,
  fn: (clock) => {
    if (Array.isArray(clock)) {
      return clock;
    }
    return [clock];
  },
  target: $potentialEmpEdu,
});

sample({
  clock: changeChosenPotentialEmpEduEv,
  target: $chosenPotentialEmpEdu,
});

sample({
  clock: changeChosenEmpEduImgModalEv,
  target: $chosenEmpEduImgModal,
});

// Add this sample to handlers.js
sample({
  clock: createUserFx.doneData,
  fn: (result) => result.newUser, // Extract just the new user data
  target: addUserToListEv,
});

// Update the existing createUserFx handler to close modal
sample({
  clock: createUserFx.done,
  fn: () => false,
  target: $showCreateModal,
});

sample({
  clock: changeChosenPotentialEmpEduEv,
  fn: () => true,
  target: $showCreateModal,
});
